<template>
  <div class="filter-check">
    <template
      v-for="(value, key) in filter"
      :key="key"
    >
      <FilterCheckbox
        :label="value.label"
        :icons="value.icons"
        :model-value="selected === key"
        @click="
          (e: any) => {
            selected = key
            changeTypeFilter(filterName, e.target.checked ? value.value : false)
            emits('updated', filtersToEmit)
            emits('summary', e.target.checked ? value.summary : '')
          }
        "
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import FilterCheckbox from '@/components/setup/FilterCheckbox.vue'
import type { CommonRadioFilterType } from '@/types/filter'

const props = defineProps<{
  filters: CommonRadioFilterType
}>()

const selected = ref()

const filter = Object.values(props.filters)[0]
const filterName = Object.keys(props.filters)[0]

const filtersToEmit = ref<Record<string, boolean | string>>({})
const changeTypeFilter = (key: string, e: boolean | string) => {
  filtersToEmit.value[key] = e
}

const emits = defineEmits<{
  (e: 'updated', val: typeof filtersToEmit.value): void
  (e: 'summary', val: string): void
}>()
</script>

<style lang="scss">
.filter-check {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
